import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.scss']
})
export class AboutUsComponent implements OnInit {
  // whycs_header: string = '4rem';
  constructor() { }

  ngOnInit(): void {
    this.adjustRightValue();
    window.scrollTo(0, 0);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.adjustRightValue();
  }

  adjustRightValue(): void {
    // Check if the screen width is greater than 1200px
    // if (window.innerWidth > 1200) {
    //   this.whycs_header = '15rem';
    // } else {
    //   this.whycs_header = '-26rem';
    // }
  }
}
